import React from "react";
import JobPostEdit from "./JobPostEdit";
import Section from "./Section";

const BookMarkJobPost = () => {
  return (
    <React.Fragment>
      <Section />
      <JobPostEdit />
    </React.Fragment>
  );
};

export default BookMarkJobPost;
